import { createAsyncThunk } from '@reduxjs/toolkit';
import engagementsApi from '../../../../store/api/engagements.api';
import { getLocalStorageEngagementId, getLocalStorageEngagementItemId } from '../../../_core/utils';

export const initiateEngagement = createAsyncThunk(
	'engagements/initiateEngagement',
	async ({ isLL }: { isLL: boolean }, { dispatch }) => {
		const currentEngagementId = getLocalStorageEngagementId();
		const currentEngagementItemId = getLocalStorageEngagementItemId();
		if (currentEngagementId) {
			const endpoint = isLL
				? engagementsApi.endpoints.getEngagementFromLinguistLink
				: engagementsApi.endpoints.getEngagement;

			await dispatch(
				endpoint.initiate(
					{ id: currentEngagementId, engagementItemId: currentEngagementItemId },
					{ forceRefetch: true }
				)
			);
		}
	}
);
